module.exports = __webpack_public_path__ + "assets/imgs/logos/ohm-smalldata.f9452d9de8e6e574cae7b40a52dad126.svg";